module.exports = __webpack_public_path__ + "img/pin.93eed615.svg";